import React from 'react'
import { Box, Grid, List } from '@material-ui/core'

import CardWrapper from '../admin/CardWrapper'
import TitleCard from '../common/TitleCard'
import AddOnSubscription from './AddOnSubscription'

function CardAddOns() {
  return (
    <>
      <CardWrapper>
        <Grid container>
          <Grid item sm={12} xs={12}>
            <TitleCard>Add-ons</TitleCard>
          </Grid>
        </Grid>
        <Box paddingTop={2} paddingBottom={2}>
          <List>
            <AddOnSubscription />
          </List>
        </Box>
      </CardWrapper>
    </>
  )
}

export default CardAddOns
